import {Pipe, PipeTransform, inject} from '@angular/core';
import {CommonTokenStorage} from '../services/common-token-storage.service';

@Pipe({
  name: 'rtlWordReorder'
})
export class RtlWordReorderPipe implements PipeTransform {
  protected tokenStorage: CommonTokenStorage = inject(CommonTokenStorage);
  curLang: string = this.tokenStorage.getCurrentLanguage();

  transform(value: string): string {
    if (!value || this.curLang !== "ar" || !this.hasRtlWords(value)) return value;
    // Split the text into words
    const words: string[] = value.split(' ');

    // Check if the string starts or ends with Ltr
    const startsWithLtr: boolean = !this.hasRtlWords(words[0]);
    const endsWithLtr: boolean = !this.hasRtlWords(words[words.length - 1]);

    const ltrWords: string[] = [];
    const rtlWords: string[] = [];

    // Split the words into Ltr and Rtl
    words.forEach(word => {
      if (this.hasRtlWords(word)) {
        rtlWords.push(word);
      } else {
        ltrWords.push(word);
      }
    });

    // Reorder only if Ltr is at the start or end
    if (startsWithLtr && endsWithLtr) {
      return [...ltrWords, ...rtlWords].join(' ');
    } else if (startsWithLtr) {
      return [...ltrWords, ...rtlWords].join(' ');
    } else if (endsWithLtr) {
      return [...rtlWords, ...ltrWords].join(' ');
    } else {
      // If the Ltr word is in the middle, don't reorder
      return value;
    }
  }

  hasRtlWords(text: string): boolean {
    const rtlRegex = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\u0700-\u074F]+/;
    return rtlRegex.test(text);
  }
}
